import {
  RequestSetCampaignMinimumRates,
  ResponseCampaignMinimumRates,
  ResponseProductMinimumRates,
  ProductType,
  AttributionWindow,
} from '@ads/front-core/api'
import Joi from '@ads/front-core/utils/joi'
import { ITextInput } from '@ads/front-core/components/Form/TextInput'
import { PRODUCTS_MIN_RATES } from '@ads/front-core/constants/products'

type ProductConfigItem = {
  withDevices: boolean
  type: ITextInput['type']
  rateKeys: ('DEFAULT' | AttributionWindow)[]
}

export type ProductConfig = {
  productType: ProductType
} & ProductConfigItem

export const minimumRatesValidation = Joi.object<ResponseCampaignMinimumRates>().pattern(
  Joi.string(),
  Joi.object<ResponseProductMinimumRates>().keys({
    valueDesktopMin: Joi.number()
      .allow('', null)
      .optional()
      .when('valueDesktopMax', {
        is: Joi.number().required(),
        then: Joi.number().max(Joi.ref('valueDesktopMax')).messages({
          'number.max':
            'Wartość minimalna (desktop) nie może być większa niż wartość maksymalna',
        }),
        otherwise: Joi.number().allow('', null).optional(),
      }),
    valueMobileMin: Joi.number()
      .allow('', null)
      .optional()
      .when('valueMobileMax', {
        is: Joi.number().required(),
        then: Joi.number().max(Joi.ref('valueMobileMax')).messages({
          'number.max':
            'Wartość minimalna (mobile) nie może być większa niż wartość maksymalna',
        }),
        otherwise: Joi.number().allow('', null).optional(),
      }),
    valueMin: Joi.number()
      .allow('', null)
      .optional()
      .when('valueMax', {
        is: Joi.number().required(),
        then: Joi.number().max(Joi.ref('valueMax')).messages({
          'number.max':
            'Wartość minimalna nie może być większa niż wartość maksymalna',
        }),
        otherwise: Joi.number().allow('', null).optional(),
      }),
    valueDesktopMax: Joi.number().allow('', null).optional(),
    valueMobileMax: Joi.number().allow('', null).optional(),
    valueMax: Joi.number().allow('', null).optional(),
  }),
)

export const requestBodyMinimumRates = (
  data: ResponseCampaignMinimumRates,
): RequestSetCampaignMinimumRates =>
  Object.keys(PRODUCTS_MIN_RATES).reduce((acc, product) => {
    const productType = product as ProductType
    const config = PRODUCTS_MIN_RATES[productType]

    config.rateKeys.forEach(rateKey => {
      const item = data?.[productType]?.[rateKey]
      if (config.withDevices) {
        acc.push({
          productType,
          min: item?.valueDesktopMin || null,
          max: item?.valueDesktopMax || null,
          target: 'DESKTOP',
          attributionWindow: rateKey === 'DEFAULT' ? null : rateKey,
        })
        acc.push({
          productType,
          min: item?.valueMobileMin || null,
          max: item?.valueMobileMax || null,
          target: 'MOBILE',
          attributionWindow: rateKey === 'DEFAULT' ? null : rateKey,
        })
      } else {
        acc.push({
          productType,
          min: item?.valueMin || null,
          max: item?.valueMax || null,
          target: 'ANY',
          attributionWindow: rateKey === 'DEFAULT' ? null : rateKey,
        })
      }
    })
    return acc
  }, [] as RequestSetCampaignMinimumRates)
